import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import MultiSelectSetting from 'components/property-settings/multi-select-setting/multi-select-setting';
import { PropertyBox, PropertyLabel } from 'components/property-settings/property-shared-styles';
import { Box, Typography } from '@mui/material';

type SpringTeethProps = {
    handleTeethSettings: (propertyName: string, settingValue: { id: number }[]) => void;
    springTeeth: { id: number }[];
    isRequired?: boolean;
};

const SpringTeeth: FC<SpringTeethProps> = ({ handleTeethSettings, springTeeth, isRequired }: SpringTeethProps) => {
    const { t: translate } = useTranslation(['construction-props']);

    return (
        <PropertyBox>
            <Box display="flex">
                <PropertyLabel variant="h5">{translate('SPRING_TEETH')}</PropertyLabel>
                {isRequired && (
                    <Typography
                        component="span"
                        color="error"
                        fontSize={18}
                        sx={{ marginLeft: '2px', marginTop: '-5px' }}
                    >
                        *
                    </Typography>
                )}
            </Box>
            <MultiSelectSetting
                setting={CONSTANTS.CLASP_TEETH}
                propertyName="springTeeth"
                label="SPRING_TEETH"
                settingValue={springTeeth}
                handleTeethPropertySelection={handleTeethSettings}
            />
        </PropertyBox>
    );
};

export default SpringTeeth;
